import { render } from "./BomCell.vue?vue&type=template&id=766d0d06"
import script from "./BomCell.vue?vue&type=script&lang=js"
export * from "./BomCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__